import { Link, Navigate, useLocation, useNavigate, matchPath } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";

import "../../Assets/scss/components/sidebar-navigation.scss";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import SupportButtonIcon from "../../Assets/img/icon-customer-service.svg";
import SupportButtonIconLight from "../../Assets/img/icon-customer-service-light.svg";
import { getPermissionsService } from "../../Services/UserAction/userManagementService";
import { useDispatch } from "react-redux";
import { useTheme } from "../../Context/ThemeContext";
import { getScanningMonitoringActivePlanStatus } from "../../Services/PlanListService";
interface PropTypes {
  handelMobileMenu: Function; // function to handle mobile menu
}

const menuItems = [
  { name: "dashboard", path: "/front" },
  { name: "widget-settings", path: "/front/widget-settings" },
  { name: "integration-scripts", path: "/front/scripts" },
  { name: "my-websites", path: "/front/websites" },
  { name: "manage-plan", path: "/front/manage-plan" },
  { name: "orders", path: "/front/orders" },
  { name: "domain-report", path: "/front/domain-report" },
  { name: "image-alt-text-remediation", path: "/front/manage-image-alt-text" },
  { name: "accessibility-checker", path: "/front/accessibility-checker" },
  {
    name: "accessibility-add-on-services",
    path: "/front/addon-services/white-label-service", // default path
    children: [
      {
        path: "/front/addon-services/white-label-service",
        label: "White Label",
      },
      {
        path: "/front/addon-services/custom-branding-service",
        label: "Custom Branding",
      },
      {
        path: "/front/addon-services/live-site-translation",
        label: "Live Site Translation",
      },
      {
        path: "/front/addon-services/modify-accessibility-menu",
        label: "Modify Accessibility Menu",
      },
      { path: "/front/addon-services/pdfs", label: "Documents & PDFs" },
      {
        path: "/front/addon-services/manual-audit-report",
        label: "Manual Audit Report",
      },
      { path: "/front/addon-services/vpat-report", label: "VPAT Report" },
      {
        path: "/front/addon-services/manual-remediation",
        label: "Manual Remediation",
      },
      { path: "/front/addon-services/design-audit", label: "Design Audit" },
      {
        path: "/front/addon-services/native-mobile-app-audit",
        label: "Native Mobile App Audit",
      },
      {
        path: "/front/addon-services/web-app-spa-audit",
        label: "Web App-SPA Audit",
      },
      {
        path: "/front/addon-services/accessibility-scanning-and-monitoring",
        label: "Accessibility Scanning and Monitoring",
      },
    ],
  },
  { name: "settings", path: "/front/settings" },
];

// component to render sidebar navigation menu
const DashboardSidebarNavigation = (props: PropTypes) => {
  const { handelMobileMenu } = props;

  // Functions
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const {theme} = useTheme()
  const dispatch = useDispatch();
  const accessToken = useSelector((store: StoreProptypes) => store.accessToken);
  // Redux Data
  const { currentWebsitePlanStatus, user, currentWebsite, is_First_load } =
      useSelector((store: StoreProptypes) => store);

  const [getPermission, setGetPermission] = useState([]);

  const [isScanningMonitoring, setIsScanningMonitoring] = useState<boolean>(false)
  const [scanningMonitoringUrl, setscanningMonitoringUrl] = useState<string>('https://staging.skynetaccessibilityscan.com/autologin/bXlyYS5jb20=')

  useEffect(() => {
    if (accessToken && user) {
      getPermissionsService(
          accessToken,
          user?.id,
          dispatch,
          t,
          navigate,
          setGetPermission,
          currentWebsite,
          user?.parent_id,
          is_First_load,
          user?.department
      );
    }
  }, []);

  // State
  const [isDisableMenuItem, setIsDisableMenuItem] = useState<boolean>(false);
  const [dropdownToggle, setDropdownToggle] = useState(false);

  // check if user can access a menu
  const hasPermission = (menuName: string) => {
    if (user?.parent_id === 0 || (user?.parent_id === 1 &&  (user?.department === 0 || user?.department === 4|| user?.department === 2)) ) return true; // parent user → all access
    if (user?.parent_id === 1 && user?.department === 1) {
      const data = getPermission.some((perm: { name: string }) => perm.name === menuName);
      return data;      
    } else {
      const data = getPermission
          ?.filter((i: any) => i?.website_domain === currentWebsite?.domain)
          .some((site: any) =>
              site.permissions?.some(
                  (perm: { name: string }) => perm.name === menuName
              )
          );
      return data;
    }
  };

  useEffect(() => {
    console.log('getPermission: ', getPermission);
    if (user?.parent_id === 1 && user?.department === 1) {
      if (!getPermission?.length) return;
  
      const allowedMenus = getPermission.flatMap((i: any) =>
        i.name.toLowerCase().replace(/\s+/g, "-")
      );
  
      // First accessible menu
      let firstAccessibleMenu = menuItems.find((menu) =>
          allowedMenus.includes(menu.name)
      );
      if (!firstAccessibleMenu) return;
  
      // Dynamically get all allowed paths from menu items + children
      const allowedPathsFromMenu = menuItems
          .filter((menu) => allowedMenus.includes(menu.name))
          .flatMap((menu) => {
            if (menu.children?.length)
              return menu.children.map((child) => child.path);
            return menu.path;
          });
  
      // Add extra allowed routes that are not in sidebar but user can access
      const extraAllowedRoutes = [
        "/front/edit-profile",
        "/front/security",
        "/front/report-a-problem",
        "/front/user-activity",
        "/front/reset-password",
        "/front/autologin/:token",
        "/front/verify-twofactor",
        "/front/forgot-password",
        "/front/getting-started",
        "/front/package/:token",
        "/front/pdf-package/:token",
        "/front/enable-twofactor-authentication",
       "/front/UserManagementPasswordPage",
       "/front/accessibility-checker",
       "/front/usermanagement",
       "/front/domain-report"
      ]; // add more if needed
  
      const allowedPaths = [...allowedPathsFromMenu, ...extraAllowedRoutes];
        const isPathAllowed = (pathname: string) =>
      allowedPaths.some((pattern) => {
        // matchPath returns a match object if matched, otherwise null
        return !!matchPath({ path: pattern, end: true }, pathname);
      });
      // If current path is not allowed, redirect
      
    if (!isPathAllowed(location.pathname)) {
        if (firstAccessibleMenu.children?.length) {
          firstAccessibleMenu = {
            ...firstAccessibleMenu,
            path: firstAccessibleMenu.children[0].path,
          };
        }
        navigate(firstAccessibleMenu.path, { replace: true });
      }
    } else {

      if (!getPermission?.length || !currentWebsite) return;
  
      const permissionData = getPermission.filter(
          (i: any) => i.website_domain === currentWebsite.domain
      );
  
      const allowedMenus = permissionData.flatMap((i: any) =>
          i.permissions.map((perm: any) =>
              perm.name.toLowerCase().replace(/\s+/g, "-")
          )
      );
  
      // First accessible menu
      let firstAccessibleMenu = menuItems.find((menu) =>
          allowedMenus.includes(menu.name)
      );
      if (!firstAccessibleMenu) return;
  
      // Dynamically get all allowed paths from menu items + children
      const allowedPathsFromMenu = menuItems
          .filter((menu) => allowedMenus.includes(menu.name))
          .flatMap((menu) => {
            if (menu.children?.length)
              return menu.children.map((child) => child.path);
            return menu.path;
          });
  
      // Add extra allowed routes that are not in sidebar but user can access
      const extraAllowedRoutes = [
        "/front/edit-profile",
        "/front/security",
        "/front/report-a-problem",
        "/front/user-activity",
        "/front/reset-password",
        "/front/autologin/:token",
        "/front/verify-twofactor",
        "/front/forgot-password",
        "/front/getting-started",
        "/front/package/:token",
        "/front/pdf-package/:token",
        "/front/enable-twofactor-authentication",
       "/front/UserManagementPasswordPage",
       "/front/accessibility-checker",
       "/front/usermanagement",
       "/front/domain-report"
      ]; // add more if needed
  
      const allowedPaths = [...allowedPathsFromMenu, ...extraAllowedRoutes];
        const isPathAllowed = (pathname: string) =>
      allowedPaths.some((pattern) => {
        // matchPath returns a match object if matched, otherwise null
        return !!matchPath({ path: pattern, end: true }, pathname);
      });
      // If current path is not allowed, redirect
      
    if (!isPathAllowed(location.pathname)) {
        if (firstAccessibleMenu.children?.length) {
          firstAccessibleMenu = {
            ...firstAccessibleMenu,
            path: firstAccessibleMenu.children[0].path,
          };
        }
        navigate(firstAccessibleMenu.path, { replace: true });
      }
    }
  }, [getPermission, currentWebsite, location.pathname]);

  useEffect(() => {
    let condition =
        location.pathname === "/front/addon-services/white-label-service" ||
        location.pathname === "/front/addon-services/white-label-service/" ||
        location.pathname === "/front/addon-services/modify-accessibility-menu" ||
        location.pathname ===
        "/front/addon-services/modify-accessibility-menu/" ||
        location.pathname === "/front/addon-services/live-site-translation" ||
        location.pathname === "/front/addon-services/live-site-translation/" ||
        location.pathname === "/front/addon-services/pdfs" ||
        location.pathname === "/front/addon-services/pdfs/" ||
        location.pathname === "/front/addon-services/manual-audit-report" ||
        location.pathname === "/front/addon-services/manual-audit-report/" ||
        location.pathname === "/front/addon-services/vpat-report" ||
        location.pathname === "/front/addon-services/vpat-report/" ||
        location.pathname === "/front/addon-services/manual-remediation" ||
        location.pathname === "/front/addon-services/manual-remediation/" ||
        location.pathname === "/front/addon-services/design-audit" ||
        location.pathname === "/front/addon-services/design-audit/" ||
        location.pathname === "/front/addon-services/native-mobile-app-audit" ||
        location.pathname === "/front/addon-services/native-mobile-app-audit/" ||
        location.pathname === "/front/addon-services/web-app-spa-audit" ||
        location.pathname === "/front/addon-services/web-app-spa-audit/" ||
        location.pathname === "/front/addon-services/custom-branding-service" ||
        location.pathname === "/front/addon-services/custom-branding-service/"||
        location.pathname === "/front/addon-services/accessibility-scanning-and-monitoring" ||
        location.pathname === "/front/addon-services/accessibility-scanning-and-monitoring/";
    // check if white label or custom branding
    if (condition) {
      setDropdownToggle(true);
    } else {
      setDropdownToggle(false);
    }
  }, []);

  useEffect(() => {
    if (currentWebsite && accessToken) {
      getScanningMonitoringActivePlanStatus(accessToken, currentWebsite.domain, setIsScanningMonitoring, setscanningMonitoringUrl)
    }
  },[currentWebsite, accessToken])

  return (
      <>
        <nav className="aioa_dashboard-sidebar-nav">
          <ul>
            {user && user.department === 4 ? (
                // Partner user
                <>
                  {hasPermission("manage-plan") && (
                      <>
                        {currentWebsite?.platform !== "wix" &&
                        currentWebsite?.platform !== "shopify" &&
                        currentWebsite?.platform !== "plesk" && 
                        currentWebsite?.platform !== "AWS" ? (
                            <li>
                              <Link
                                  onClick={() => handelMobileMenu()}
                                  to="/front/manage-plan"
                                  className={`${
                                      location.pathname === "/front/manage-plan"
                                          ? `active`
                                          : ``
                                  }`}
                              >
                                <div className="nav-link-icon">
                                  <i
                                      className="material-symbols-outlined"
                                      aria-hidden="true"
                                  >
                                    money
                                  </i>
                                </div>
                                <div className="nav-link-text">{t("Manage Plan")}</div>
                              </Link>
                            </li>
                        ) : (
                            <></>
                        )}
                      </>
                  )}
                  {hasPermission("accessibility-add-on-services") && (
                      <li className={`nav-item`}>
                        <>
                          <Dropdown
                              autoClose={false}
                              show={dropdownToggle}
                              onToggle={() => setDropdownToggle(!dropdownToggle)}
                          >
                            <Dropdown.Toggle
                                id="addon-dropdown"
                                className={`addon-dropdown ${
                                    dropdownToggle ? `active` : ``
                                }`}
                            >
                              <div className={`nav-link-icon`}>
                                <i
                                    className="material-symbols-outlined"
                                    aria-hidden="true"
                                >
                                  accessibility_new
                                </i>
                              </div>
                              <div className={`nav-link-text`}>
                                {t("Accessibility Add-On Services")}
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="addon-dropdown-menu">
                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/manual-audit-report" ||
                                        location.pathname ===
                                        "/front/addon-services/manual-audit-report/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/manual-audit-report"
                                >
                                  <div className="nav-link-text">
                                    {t("Manual Accessibility Audit Report")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/manual-remediation" ||
                                        location.pathname ===
                                        "/front/addon-services/manual-remediation/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/manual-remediation"
                                >
                                  <div className="nav-link-text">
                                    {t("Manual Accessibility Remediation")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              {!currentWebsitePlanStatus.isExpired && (
                                  <>
                                    <Dropdown.Item as={`div`}>
                                      <Link
                                          onClick={() => handelMobileMenu()}
                                          className={`${
                                              location.pathname ===
                                              "/front/addon-services/pdfs/" ||
                                              location.pathname ===
                                              "/front/addon-services/pdfs"
                                                  ? `active text-primary`
                                                  : ``
                                          }`}
                                          to="/front/addon-services/pdfs"
                                      >
                                        <div className="nav-link-text">
                                          {t("PDF/Document Accessibility Remediation")}
                                        </div>
                                      </Link>
                                    </Dropdown.Item>
                                  </>
                              )}
                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/vpat-report" ||
                                        location.pathname ===
                                        "/front/addon-services/vpat-report/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/vpat-report"
                                >
                                  <div className="nav-link-text">
                                    {t(
                                        "VPAT Report/Accessibility Conformance Report(ACR)"
                                    )}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    to="/front/addon-services/white-label-service"
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/white-label-service"
                                            ? `active`
                                            : ``
                                    }`}
                                >
                                  <div className="nav-link-text">
                                    {t("White Label")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link onClick={() => handelMobileMenu()} className={`${location.pathname === '/front/addon-services/accessibility-scanning-and-monitoring' || location.pathname === '/front/addon-services/accessibility-scanning-and-monitoring/' ? `active text-primary` : ``}`} to={isScanningMonitoring ? scanningMonitoringUrl : "/front/addon-services/accessibility-scanning-and-monitoring"} target={isScanningMonitoring ? '_blank' : ''}>
                                  <div className="nav-link-text">{t("Accessibility Scanning and Monitoring")}</div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/custom-branding-service" ||
                                        location.pathname ===
                                        "/front/addon-services/custom-branding-service/"
                                            ? `active`
                                            : ``
                                    }`}
                                    to="/front/addon-services/custom-branding-service"
                                >
                                  <div className="nav-link-text">
                                    {t("Custom Branding")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/live-site-translation" ||
                                        location.pathname ===
                                        "/front/addon-services/live-site-translation/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/live-site-translation"
                                >
                                  <div className="nav-link-text">
                                    {t("Live Site Translation")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    to="/front/addon-services/modify-accessibility-menu"
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/modify-accessibility-menu" ||
                                        location.pathname ===
                                        "/front/addon-services/modify-accessibility-menu/"
                                            ? `active`
                                            : ``
                                    }`}
                                >
                                  <div className="nav-link-text">
                                    {t("Modify Accessibility Menu")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/design-audit" ||
                                        location.pathname ===
                                        "/front/addon-services/design-audit/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/design-audit"
                                >
                                  <div className="nav-link-text">
                                    {t("Design Audit")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/native-mobile-app-audit" ||
                                        location.pathname ===
                                        "/front/addon-services/native-mobile-app-audit/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/native-mobile-app-audit"
                                >
                                  <div className="nav-link-text">
                                    {t("Native Mobile App Audit label")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/web-app-spa-audit" ||
                                        location.pathname ===
                                        "/front/addon-services/web-app-spa-audit/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/web-app-spa-audit"
                                >
                                  <div className="nav-link-text">
                                    {t("Web App-SPA Audit")}
                                  </div>
                                </Link>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </>
                      </li>
                  )}
                  {hasPermission("orders") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/orders"
                            className={`${
                                location.pathname === "/front/orders" ? `active` : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              list_alt
                            </i>
                          </div>
                          <div className="nav-link-text">{t("Orders")}</div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("widget-settings") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/widget-settings"
                            className={`${
                                location.pathname === "/front/widget-settings"
                                    ? `active`
                                    : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              settings
                            </i>
                          </div>
                          <div className="nav-link-text">{t("Widget Settings")}</div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("integration-scripts") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/scripts"
                            tabIndex={isDisableMenuItem ? -1 : 0}
                            aria-hidden={isDisableMenuItem ? true : false}
                            className={`${isDisableMenuItem ? `disabled` : ``} ${
                                location.pathname === "/front/scripts" ? `active` : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              code
                            </i>
                          </div>
                          <div className="nav-link-text">
                            {t("Script Integration")}
                          </div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("domain-report") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/domain-report"
                            className={`${
                                location.pathname === "/front/domain-report"
                                    ? `active`
                                    : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              insert_chart
                            </i>
                          </div>
                          <div className="nav-link-text">{t("Domain Report")}</div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("image-alt-text-remediation") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/manage-image-alt-text"
                            className={`${
                                location.pathname === "/front/manage-image-alt-text"
                                    ? `active`
                                    : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              image
                            </i>
                          </div>
                          <div className="nav-link-text">
                            {t("Image Alt Text Remediation")}
                          </div>
                        </Link>
                      </li>
                  )}

                  {hasPermission("accessibility-checker") && (
                      <li>
                        <Link onClick={() => handelMobileMenu()} to="/front/accessibility-checker" className={`${location.pathname === '/front/accessibility-checker' ? `active` : ``}`}>
                          <div className="nav-link-icon"><i className="material-symbols-outlined" aria-hidden="true">task_alt</i></div>
                          <div className="nav-link-text">{t("accessibility checker")}</div>
                        </Link>
                      </li>
                  )}

                </>
            ) : (
                // Normal user Menu
                <>
                  {hasPermission("integration-scripts") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/scripts"
                            tabIndex={isDisableMenuItem ? -1 : 0}
                            aria-hidden={isDisableMenuItem ? true : false}
                            className={`${isDisableMenuItem ? `disabled` : ``} ${
                                location.pathname === "/front/scripts" ? `active` : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              code
                            </i>
                          </div>
                          <div className="nav-link-text">
                            {t("Script Integration")}
                          </div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("dashboard") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front"
                            tabIndex={isDisableMenuItem ? -1 : 0}
                            aria-hidden={isDisableMenuItem ? true : false}
                            className={`${isDisableMenuItem ? `disabled` : ``} ${
                                location.pathname === "/front" ? `active` : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              dashboard
                            </i>
                          </div>
                          <div className="nav-link-text">{t("Dashboard")}</div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("widget-settings") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/widget-settings"
                            tabIndex={isDisableMenuItem ? -1 : 0}
                            aria-hidden={isDisableMenuItem ? true : false}
                            className={`${isDisableMenuItem ? `disabled` : ``} ${
                                location.pathname === "/front/widget-settings"
                                    ? `active`
                                    : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              settings
                            </i>
                          </div>
                          <div className="nav-link-text">{t("Widget Settings")}</div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("my-websites") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/websites"
                            className={`${
                                location.pathname === "/front/websites" ? `active` : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              public
                            </i>
                          </div>
                          <div className="nav-link-text">{t("My Websites")}</div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("image-alt-text-remediation") && (
                      <li>
                        <Link
                            onClick={() => handelMobileMenu()}
                            to="/front/manage-image-alt-text"
                            tabIndex={isDisableMenuItem ? -1 : 0}
                            aria-hidden={isDisableMenuItem ? true : false}
                            className={`${isDisableMenuItem ? `disabled` : ``} ${
                                location.pathname === "/front/manage-image-alt-text"
                                    ? `active`
                                    : ``
                            }`}
                        >
                          <div className="nav-link-icon">
                            <i
                                className="material-symbols-outlined"
                                aria-hidden="true"
                            >
                              image
                            </i>
                          </div>
                          <div className="nav-link-text">
                            {t("Image Alt Text Remediation")}
                          </div>
                        </Link>
                      </li>
                  )}
                  {hasPermission("accessibility-add-on-services") && (
                      <li className={`nav-item`}>
                        <>
                          <Dropdown
                              autoClose={false}
                              show={dropdownToggle}
                              onToggle={() => setDropdownToggle(!dropdownToggle)}
                          >
                            <Dropdown.Toggle
                                id="addon-dropdown"
                                className={`addon-dropdown ${
                                    dropdownToggle ? `active` : ``
                                }`}
                            >
                              <div className={`nav-link-icon`}>
                                <i
                                    className="material-symbols-outlined"
                                    aria-hidden="true"
                                >
                                  accessibility_new
                                </i>
                              </div>
                              <div className={`nav-link-text`}>
                                {t("Accessibility Add-On Services")}
                              </div>
                            </Dropdown.Toggle>

                            <Dropdown.Menu className="addon-dropdown-menu">
                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    to="/front/addon-services/white-label-service"
                                    tabIndex={isDisableMenuItem ? -1 : 0}
                                    aria-hidden={isDisableMenuItem ? true : false}
                                    className={`${
                                        isDisableMenuItem ? `disabled` : ``
                                    } ${
                                        location.pathname ===
                                        "/front/addon-services/white-label-service"
                                            ? `active`
                                            : ``
                                    }`}
                                >
                                  <div className="nav-link-text">
                                    {t("White Label")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link onClick={() => handelMobileMenu()} className={`${(location.pathname === '/front/addon-services/accessibility-scanning-and-monitoring' || location.pathname === '/front/addon-services/accessibility-scanning-and-monitoring/') ? `active text-primary` : ``}`} to={isScanningMonitoring ? scanningMonitoringUrl : "/front/addon-services/accessibility-scanning-and-monitoring"} target={isScanningMonitoring ? '_blank' : ''}>
                                  <div className="nav-link-text">{t("Accessibility Scanning and Monitoring")}</div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    to="/front/addon-services/modify-accessibility-menu"
                                    tabIndex={isDisableMenuItem ? -1 : 0}
                                    aria-hidden={isDisableMenuItem ? true : false}
                                    className={`${
                                        isDisableMenuItem ? `disabled` : ``
                                    } ${
                                        location.pathname ===
                                        "/front/addon-services/modify-accessibility-menu" ||
                                        location.pathname ===
                                        "/front/addon-services/modify-accessibility-menu/"
                                            ? `active`
                                            : ``
                                    }`}
                                >
                                  <div className="nav-link-text">
                                    {t("Modify Accessibility Menu")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    tabIndex={isDisableMenuItem ? -1 : 0}
                                    aria-hidden={isDisableMenuItem ? true : false}
                                    className={`${
                                        isDisableMenuItem ? `disabled` : ``
                                    } ${
                                        location.pathname ===
                                        "/front/addon-services/live-site-translation" ||
                                        location.pathname ===
                                        "/front/addon-services/live-site-translation/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/live-site-translation"
                                >
                                  <div className="nav-link-text">
                                    {t("Live Site Translation")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    tabIndex={isDisableMenuItem ? -1 : 0}
                                    aria-hidden={isDisableMenuItem ? true : false}
                                    className={`${
                                        isDisableMenuItem ? `disabled` : ``
                                    } ${
                                        location.pathname ===
                                        "/front/addon-services/pdfs/" ||
                                        location.pathname === "/front/addon-services/pdfs"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/pdfs"
                                >
                                  <div className="nav-link-text">
                                    {t("Documents & PDFs")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/manual-audit-report" ||
                                        location.pathname ===
                                        "/front/addon-services/manual-audit-report/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/manual-audit-report"
                                >
                                  <div className="nav-link-text">
                                    {t("Manual Audit Report")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/vpat-report" ||
                                        location.pathname ===
                                        "/front/addon-services/vpat-report/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/vpat-report"
                                >
                                  <div className="nav-link-text">
                                    {t("VPAT Report")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/manual-remediation" ||
                                        location.pathname ===
                                        "/front/addon-services/manual-remediation/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/manual-remediation"
                                >
                                  <div className="nav-link-text">
                                    {t("Manual Remediation")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/design-audit" ||
                                        location.pathname ===
                                        "/front/addon-services/design-audit/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/design-audit"
                                >
                                  <div className="nav-link-text">
                                    {t("Design Audit")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/native-mobile-app-audit" ||
                                        location.pathname ===
                                        "/front/addon-services/native-mobile-app-audit/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/native-mobile-app-audit"
                                >
                                  <div className="nav-link-text">
                                    {t("Native Mobile App Audit label")}
                                  </div>
                                </Link>
                              </Dropdown.Item>

                              <Dropdown.Item as={`div`}>
                                <Link
                                    onClick={() => handelMobileMenu()}
                                    className={`${
                                        location.pathname ===
                                        "/front/addon-services/web-app-spa-audit" ||
                                        location.pathname ===
                                        "/front/addon-services/web-app-spa-audit/"
                                            ? `active text-primary`
                                            : ``
                                    }`}
                                    to="/front/addon-services/web-app-spa-audit"
                                >
                                  <div className="nav-link-text">
                                    {t("Web App-SPA Audit")}
                                  </div>
                                </Link>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </>
                      </li>
                  )}
                  {hasPermission("manage-plan") && (
                      <>
                        {currentWebsite?.platform !== "wix" &&
                        currentWebsite?.platform !== "shopify" &&
                        currentWebsite?.platform !== "plesk" && 
                        currentWebsite?.platform !== "AWS" ? (
                            <li>
                              <Link
                                  onClick={() => handelMobileMenu()}
                                  to="/front/manage-plan"
                                  className={`${
                                      location.pathname === "/front/manage-plan"
                                          ? `active`
                                          : ``
                                  }`}
                              >
                                <div className="nav-link-icon">
                                  <i
                                      className="material-symbols-outlined"
                                      aria-hidden="true"
                                  >
                                    money
                                  </i>
                                </div>
                                <div className="nav-link-text">{t("Manage Plan")}</div>
                              </Link>
                            </li>
                        ) : (
                            <></>
                        )}
                      </>
                  )}
                  {hasPermission("orders") && (
                    <>
                      {currentWebsite?.platform !== "wix" &&
                        currentWebsite?.platform !== "shopify" &&
                        currentWebsite?.platform !== "plesk" && 
                        currentWebsite?.platform !== "AWS" ? (
                          <li>
                            <Link
                                onClick={() => handelMobileMenu()}
                                to="/front/orders"
                                className={`${
                                    location.pathname === "/front/orders" ? `active` : ``
                                }`}
                            >
                              <div className="nav-link-icon">
                                <i
                                    className="material-symbols-outlined"
                                    aria-hidden="true"
                                >
                                  list_alt
                                </i>
                              </div>
                              <div className="nav-link-text">{t("Orders")}</div>
                            </Link>
                          </li>
                        ) : (
                            <></>
                        )}
                      </>
                  )}
                </>
            )}
            {hasPermission("support") && (
                <li className="support-btn">
                  <a
                      target={`_blank`}
                      href="https://www.skynettechnologies.com/report-accessibility-problem"
                      onClick={() => handelMobileMenu()}
                  >
                    <div className="nav-link-icon">
                    {theme === 'light' ? 
                        <img src={SupportButtonIcon} alt="" aria-hidden="true" />
                        :
                        <img src={SupportButtonIconLight} alt="" aria-hidden="true" />
                    }
                    </div>
                    <div className="nav-link-text">{t("Support")}</div>
                  </a>
                </li>
            )}
          </ul>
        </nav>
      </>
  );
};

export default DashboardSidebarNavigation;
